import { useGetUnreads } from "api/user/getUnreads";
import { useGetUser } from "api/user/getUser";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export const withAuth = (Component) => {
  return function Wrapper(props) {
    const dispatch = useDispatch();
    const auth = useSelector((state) => state.auth, shallowEqual);
    const { data } = useGetUnreads();
    const { data: userData } = useGetUser();
    const { i18n } = useTranslation();

    useEffect(() => {
      if (userData) {
        dispatch({
          type: "SET_USER",
          payload: userData,
        });

        i18n.changeLanguage(
          userData.languageCode
        );
      }
    }, [dispatch, userData]);

    useEffect(() => {
      if (data) {
        dispatch({
          type: "SET_UNREADS",
          payload: data,
        });
      }
    }, [data]);

    if (!auth.logged) {
      return <Navigate replace to={"/login"} />;
    }

    return <Component {...props} />;
  };
};
